import type { Ref } from "@sitescene/types";

/** Ids as the API sends them and as staff paste them. */

/** The id behind a ref, whether the API sent it bare or populated. */
export const refId = <T extends { id: string }>(ref: Ref<T>): string =>
	typeof ref === "string" ? ref : ref.id;

/**
 * An event id from what staff paste: the bare id, or a dashboard link whose
 * last path segment is the id (query string and fragment ignored).
 */
export const parseEventId = (input: string): string => {
	const trimmed = input.trim();
	if (!trimmed.includes("/")) return trimmed;
	const path = trimmed.split(/[?#]/)[0] ?? "";
	const segments = path.split("/").filter(Boolean);
	return segments[segments.length - 1] ?? "";
};
